import React, {useContext} from "react";
import {Link} from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import {thisBaseURL} from "../../utils/helper";

function HeaderNoAuth() {
	const userCtx = useContext(UserContext);
	
	return (
		<div>
			<head>
			    <title>Fair | Food Adulteration Incidents Registry</title>
		  	</head>
			<div className="mean-bar">
				<a className="meanmenu-reveal" href="#nav" style={{right:"0px", left:"auto", textAlign:"center", textIndent:"0px", fontSize:"18px"}}>
				<span></span>
				<span></span>
				<span></span>
				</a>
			</div>
			<div className="header-container">
				<header className="header" id="header" role="banner">
					<a className="header__logo" href={thisBaseURL} id="logo">
						<img alt="Home" className="header__logo-image" src="images/FairLogo.png" />
					</a>
					<div id="navigation">
						<ul>
							<li><br /><Link reloadDocument to="/about">ABOUT US</Link></li>
							<li>
								<Link to="/sign_in">Sign In OR</Link>
								<div className="promote">
									<Link reloadDocument to="/sign_up">Sign Up</Link>
								</div>
							</li>
						</ul>
					</div>
				</header>
			</div>
			<div className="blue-bar">
				<div>
					<div className="chevron-image blue-bar">
					<p><img alt="Home" style={{width:"27px", height: "28px"}} src="images/chevron_0.png" /></p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default HeaderNoAuth;
